<template>
  <div>
    <!--Map Section Start-->
    <section class="p-0">
      <div class="container-fluid">
        <div class="bottom-section">
          <div class="row">
            <div class="col-md-6 p-0">
              <div class="address-bar">
                <div>
                  <ul class="footer-style">
                    <li>
                      <div class="footer-icon">
                        <img :src='"../assets/images/locate.png"' alt="locate">
                      </div>
                      <div class="footer-address">
                        <a :href=" `https://maps.google.com/maps?q=%D0%94%D0%B5%D0%B3%D1%82%D1%8F%D1%80%D1%96%D0%B2%D1%81%D1%8C%D0%BA%D0%B0%2C%2062%2C%20Kyiv%2C%20Ukraine&hl=${$t('language')}`">{{$t("map.adress")}}</a>
                      </div>
                    </li>
                    <li>
                      <div class="footer-icon">
                        <img :src='"../assets/images/telephone.png"' alt="telephone">
                      </div>
                      <div class="footer-address">
                        <a href="tel:(096)%20853-8888">(096) 853-8888</a>
                      </div>
                    </li>
                    <li>
                      <div class="footer-icon">
                        <img :src='"../assets/images/mail.png"' alt="email">
                      </div>
                      <div class="footer-address">
                        <a href="mailto:support@tf-ua.com">support@tf-ua.com</a>
                      </div>
                    </li>
                    </ul>
                </div>
              </div>
            </div>
            <div class="col-md-6 p-0">
              <iframe :src=" `https://maps.google.com/maps?q=%D0%94%D0%B5%D0%B3%D1%82%D1%8F%D1%80%D1%96%D0%B2%D1%81%D1%8C%D0%BA%D0%B0%2C%2062%2C%20Kyiv%2C%20Ukraine&amp;t=m&amp;z=15&amp;output=embed&amp;iwloc=near&hl=${$t('language')}`" v-bind:title="$t('map.adress')" v-bind:aria-label="$t('map.adress')"></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--Map Section Ends-->
  </div>
</template>
<script>
export default {
  name: 'Map'
}
</script>




// WEBPACK FOOTER //
// src/components/map.vue